import { useCallback } from 'react';
import { SingleValue } from 'react-select';

import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import playersRepository from 'modules/players/domain/repositories/player.repository';
import { getFullName } from 'shared/utils';
import { UDAsyncSelect } from 'ud-form/components/select/component';
import { UDText } from 'ud-ui/components';
import { PlayerSelectOption, playerToPlayerOption } from './player-option';

/** Выдача поиска игроков — длиннее командной, ФИО чаще совпадают. */
const SEARCH_LIMIT = 30;

const selectComponents = {
  SingleValue: (props: any) => (
    <div>
      <UDText type="subhead">{getFullName(props.data?.value)}</UDText>
    </div>
  ),
};

interface PlayerAsyncSelectProps {
  value: PlayerSelectOption | null;
  onChange: (option: SingleValue<PlayerSelectOption>) => void;
  autoFocus?: boolean;
  className?: string;
  placeholder?: string;
}

/**
 * Поиск игрока текущей организации по ФИО.
 *
 * Организацию берёт сам — вызывающей стороне остаётся принять выбранного игрока.
 * Используется там, где игрока надо к чему-то привязать: сейчас это добавление в состав
 * команды.
 */
export function PlayerAsyncSelect({ value, onChange, autoFocus, className, placeholder = 'Введите ФИО игрока' }: PlayerAsyncSelectProps) {
  const { info } = useOrganizer();
  const tournamentId = info?.id;

  const handleLoadOptions = useCallback(
    async (inputValue: string) => {
      if (!tournamentId) return [];

      const players = await playersRepository.fetchTournamentUsers({
        tournamentId,
        limit: SEARCH_LIMIT,
        offset: 0,
        nameFilter: inputValue,
      });

      return players.map(playerToPlayerOption);
    },
    [tournamentId],
  );

  return (
    <UDAsyncSelect<PlayerSelectOption>
      autoFocus={autoFocus}
      className={className}
      placeholder={placeholder}
      components={selectComponents}
      loadOptions={handleLoadOptions}
      value={value}
      onChange={onChange}
    />
  );
}
